<template>
  <div class="icon-with-caption inline-flex items-center gap-050">
    <LcIcon class="icon-secondary-secondary" :name="icon" size="small" />
    <span class="caption-bold font-medium">
      {{ caption }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { LcIconName } from '@lottocom/frontend-components'

type IconWithCaptionProps = {
  caption: string
  icon: LcIconName
}

defineProps<IconWithCaptionProps>()
</script>

<style lang="scss" scoped>
.icon-with-caption {
  span {
    line-height: 1;
  }
}
</style>
